import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./Typography.module.scss";

export default function Danger(props) {
  const { children } = props;
  return (
    <div className={`${styles.defaultFontStyle} ${styles.dangerText}`}>
      {children}
    </div>
  );
}

Danger.propTypes = {
  children: PropTypes.node
};
